<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xelknq/preview/previewcover.jpg?1731705612877" alt="This image is the cover for the book Eros Descending, Tales of the Velvet Comet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eros Descending, Tales of the Velvet Comet
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A religious fanatic wages war on an intergalactic bordello in this classic space opera by a five-time Hugo Award–winning author.</b><br/><br/> The crown jewel of the Vainmill Syndicate’s Entertainment and Leisure Division is <i>Velvet Comet</i>. This exclusive, extravagant, and exotic pleasure palace, orbiting Deluros VIII, is the go-to place for the rich and famous to play, relax, and indulge. But one of the guests has come for an entirely different purpose . . .<br/><br/> The Reverend Thomas Gold—or Doctor Gold, as he prefers—is the leader of a fanatical religious sect. He is also a very vocal enemy of the Syndicate, eager to have them close the hedonistic <i>Comet</i> for good.<br/><br/> But then Doctor Gold meets the <i>Comet</i>’s two most popular employees, Titania and Oberon: two beautiful, blue-skinned, elfin Andrican aliens. They love their jobs, but Doctor Gold only sees their enslavement and declares their liberation to be his latest crusade. And so begins a war that will either end in the <i>Comet</i>’s destruction . . . or his.<br/><br/><b>The perfect choice for readers of Alan Dean Foster, Timothy Zahn, and Joe Haldeman.<br/><br/> Praise for the Tales of the Velvet Comet series<br/><br/> “A goodie. . . . Buy it, and join me in wondering what Mike will do with the next volumes in the series.” —<i>Analog</i> on <i>Eros Ascending</i><br/><br/> “Well plotted, good characterizations, and an exotic setting. As good a mystery novel as it is science fiction.” —<i>Science Fiction Chronicle </i>on <i>Eros at Zenith</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Resnick
      </h2>
      
      <p class="authorDescription body article">Mike Resnick (1942&ndash;2020) was an American science fiction author and editor. A winner of five Hugo Awards and a Nebula Award, Resnick was hugely popular in the world of fandom and was the guest of honor at many&#160;science fiction conventions, including Chicon 7, the World Science Fiction Convention in Chicago. He was the executive editor of&#160;<I>Jim Baen&rsquo;s Universe</I>, as well as the editor and co-creator of&#160;<I>Galaxy&rsquo;s Edge</I>&#160;magazine. In addition to publishing hundreds of books, Resnick was known for helping new writers start their careers. The Mike Resnick Memorial Award was created in 2021 to honor his memory and carry on his legacy by spotlighting new writers of short fiction in the genre.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3521afd6